import { render, staticRenderFns } from "./assignment-video-player.vue?vue&type=template&id=5389dfd8&scoped=true"
import script from "./assignment-video-player.vue?vue&type=script&lang=js"
export * from "./assignment-video-player.vue?vue&type=script&lang=js"
import style0 from "./assignment-video-player.css?vue&type=style&index=0&id=5389dfd8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389dfd8",
  null
  
)

export default component.exports